import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="bg-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={logo}
              alt="CodeSplash Logo" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary transition-colors">
              Home
            </Link>
            
            {/* Services Dropdown */}
            <div className="relative group">
              <button
                className="flex items-center text-gray-700 group-hover:text-primary transition-colors py-2"
              >
                Services
                <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Invisible element to bridge any gap */}
              <div className="absolute -bottom-2 left-0 right-0 h-2 bg-transparent"></div>
              
              <div className="absolute left-0 top-full w-48 bg-white rounded-lg shadow-xl py-2 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300 z-50">
                <Link to="/services/development" className="block px-4 py-2 text-gray-700 hover:bg-primary hover:text-white">
                  Development
                </Link>
                <Link to="/services/ui-design" className="block px-4 py-2 text-gray-700 hover:bg-primary hover:text-white">
                  UI Design
                </Link>
                <Link to="/services/branding" className="block px-4 py-2 text-gray-700 hover:bg-primary hover:text-white">
                  Branding
                </Link>
                <Link to="/services/graphic-design" className="block px-4 py-2 text-gray-700 hover:bg-primary hover:text-white">
                  Graphic Design
                </Link>
              </div>
            </div>

            {/* <Link to="/about" className="text-gray-700 hover:text-primary transition-colors">
              About
            </Link>
            <Link to="/case-studies" className="text-gray-700 hover:text-primary transition-colors">
              Case Studies
            </Link>
            <Link to="/blog" className="text-gray-700 hover:text-primary transition-colors">
              Blog
            </Link> */}
            <Link to="/pricing" className="text-gray-700 hover:text-primary transition-colors">
              Pricing
            </Link>
            <Link to="/login" className=" text-red-500 px-6 py-2 rounded-full hover:bg-primary/90 hover:text-white transition-colors">
              Login
            </Link>
            <Link to="/signup" className="bg-white border border-primary text-primary px-6 py-2 rounded-full hover:bg-primary/90 hover:text-white transition-colors">
              Get Started
            </Link>
            <Link to="/login" className="bg-primary text-white px-6 py-2 rounded-full hover:bg-primary/90 transition-colors">
              Book a Call
            </Link>
          
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-primary"
            onClick={toggleMenu}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden pb-4">
            <Link to="/" className="block py-2 text-gray-700 hover:text-primary">
              Home
            </Link>
            <div className="relative">
              <button
                className="w-full text-left py-2 text-gray-700 hover:text-primary flex items-center justify-between"
                onClick={() => {
                  const submenu = document.getElementById('mobile-services-submenu');
                  submenu?.classList.toggle('hidden');
                }}
              >
                Services
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div id="mobile-services-submenu" className="hidden pl-4">
                <Link to="/services/development" className="block py-2 text-gray-700 hover:text-primary">
                  Development
                </Link>
                <Link to="/services/ui-design" className="block py-2 text-gray-700 hover:text-primary">
                  UI Design
                </Link>
                <Link to="/services/branding" className="block py-2 text-gray-700 hover:text-primary">
                  Branding
                </Link>
                <Link to="/services/graphic-design" className="block py-2 text-gray-700 hover:text-primary">
                  Graphic Design
                </Link>
              </div>
            </div>
            <Link to="/about" className="block py-2 text-gray-700 hover:text-primary">
              About
            </Link>
            <Link to="/case-studies" className="block py-2 text-gray-700 hover:text-primary">
              Case Studies
            </Link>
            <Link to="/blog" className="block py-2 text-gray-700 hover:text-primary">
              Blog
            </Link>
            <Link to="/pricing" className="block py-2 text-gray-700 hover:text-primary">
              Pricing
            </Link>
            <Link to="/login" className="block py-2 text-gray-700 hover:text-primary">
              Login
            </Link>
            <Link to="/contact" className="block py-2 text-gray-700 hover:text-primary">
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 